// import React from 'react'
// import IframeLoader from '../../IframeLoader'

// function MyRewards() {
//     return (
//         <IframeLoader route="my-rewards" />
//     )
// }

// export default MyRewards

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import "../../../../css/table.css";
import "../../../../css/MyRewards.css";
import moment from "moment";
import { useDispatch } from "react-redux";
import { BaseUrl } from "../../../../Shared";
import Web3 from "web3";
import Cookies from "universal-cookie";
import {
  BrowserRouter as Router,
  useHistory,
  useLocation,
} from "react-router-dom";
import axios from "axios";

import nfmClaimRewardsAbi from "../../../../Shared/nfmClaimRewardsAbi.json";
import nfmClaim from "../../../../Shared/nfmClaim.json";
import constants from "../../../../Shared/constants/constants";
import swal from "sweetalert";
import { getWalletAddress } from "../../../../store/selectors/WalletSelectors";

const cookies = new Cookies();

const MyRewards = () => {
  const [allproducts, setAllproducts] = useState([]);
  const dispatch = useDispatch();
  const [isproducts, setIsProducts] = useState(false);
  const [isresponse, setIsresponse] = useState(false);
  const history = useHistory();
  const userId = localStorage.getItem("loginUserId");
  const loginUserToken = localStorage.getItem("loginUserToken");
  const [rewardType, setRewardType] = useState("");
  const [rewardResponse, setRewardResponse] = useState([]);
  const [nextClaimTime, setNextClaimTime] = useState(0);
  const [nextClaimTimeString, setNextClaimTimeString] = useState('');
  const [ifClaimDateArrived, setIfClaimDateArrived] = useState(false);
  const [claimAble, setClaimAble] = useState(0);
  const [claimedAmount, setClaimedAmount] = useState(0);

  const [web3, setWeb3] = useState(null);
  const [isWalletConnected, setWalletConnected] = useState(false);

  const connectedWallet = useSelector((state) => getWalletAddress(state)) || "";

  const refreshPage = () => {
    window.location.reload();
  };

  const getClaimRewardsSignature = async () => {
    console.log("claim reward executing");
    try {
      var axios = require("axios");
      if (typeof window.ethereum !== "undefined") {
        let accounts = await window.ethereum.request({
          method: "eth_requestAccounts",
        });
        window.web3 = new Web3(window.ethereum);
        setWeb3(window.web3);

        if (accounts.length == 0) {
          swal({
            icon: "error",
            title: "Failed",
            text: "Connect your wallet to proceed",
            showConfirmButton: true,
            showCancelButton: false,
            allowOutsideClick: true,
          }).then(() => {
            refreshPage();
          });
          return;
        }

        var data = JSON.stringify({
          wallet_address: accounts[0],
          amount: claimAble,
        });

        var config = {
          method: "post",
          url: `${BaseUrl}/generateNfmRewardsClaimSignature`,
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then(async function (response) {
            console.log(response);
            if (response.status == 200) {
              let result = response.data;
              let NFMClaimRewards = await new window.web3.eth.Contract(
                nfmClaimRewardsAbi,
                constants.NFMCLAIMREWARDS
              );
              // return;

              let v = 0;

              if (result.signedData.v == "0x1c") {
                v = 28;
              } else if (result.signedData.v == "0x1b") {
                v = 27;
              }

              await NFMClaimRewards.methods
                .claimRewards(
                  result.amount,
                  result.nonce,
                  v,
                  result.signedData.r,
                  result.signedData.s
                )
                .send({ from: accounts[0] })
                .on("transactionHash", function (hash) {
                  // update transaction hash - 1 with false
                  swal({
                    icon: "info",
                    title: "Please wait",
                    text: "Transaction initiated, Please wait for the transaction to confirm",
                    button: false,
                    showCancelButton: false,
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                  }).then(() => {
                    refreshPage();
                  });
                  waitTransactionReceipt(
                    hash,
                    "claim",
                    0,
                    function (err, receipt) {
                      if (err != null) {
                        return;
                      }
                    }
                  );
                })
                .on("error", function (error, receipt) {
                  console.log(
                    "[nft][src][components][pages][rewards] Approve Tx Error",
                    error
                  );
                  swal({
                    icon: "error",
                    title: "Failed",
                    text: "Transaction cancelled. Please try again!",
                    showConfirmButton: true,
                    showCancelButton: false,
                    allowOutsideClick: true,
                  }).then(() => {
                    refreshPage();
                  });
                  return;
                });
            } else {
              swal({
                icon: "error",
                title: "Failed",
                text: "Something went wrong, Please try again",
                showConfirmButton: true,
                showCancelButton: false,
                allowOutsideClick: true,
              }).then(() => {
                refreshPage();
              });
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      } else {
        console.log("[nft][src][components][pages]:: Unsupported Browser");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const waitTransactionReceipt = async (
    transactionHash,
    actionType,
    timeOut,
    callback
  ) => {
    console.log(
      "[nft][src][components][pages][rewards][waitTransactionReceipt] transactionHash",
      transactionHash
    );
    var web3 = new Web3(window.ethereum);
    let self = this;

    let timeOutCounter = 0;
    let err = {
      message: "",
    };

    let isWaitRunning = false;

    let getReceiptTimerId = setInterval(function () {
      if (isWaitRunning == false) {
        isWaitRunning = true;
        web3.eth
          .getTransaction(transactionHash)
          .then(function (tx) {
            if (tx == null) {
              clearInterval(getReceiptTimerId);
              console.log(
                `[nft][src][components][pages][rewards][waitTransactionReceipt] transactionHash ${transactionHash} is not found`
              );
              err.message = "Transaction hash is not found.";
              isWaitRunning = false;
              if (callback) {
                callback(err, null);
              }
              return;
            }

            if (tx.blockNumber == null) {
              if (timeOut > 0) {
                timeOutCounter++;
                if (timeOutCounter >= timeOut) {
                  clearInterval(getReceiptTimerId);
                  isWaitRunning = false;
                  err.message = "Timeout while waiting transaction to confirm.";
                  if (callback) {
                    callback(err, null);
                  }
                  return;
                } else {
                  console.log(
                    `[nft][src][components][pages][rewards][waitTransactionReceipt] transactionHash 1 ${transactionHash} is pending`
                  );
                  isWaitRunning = false;
                  return;
                }
              } else {
                console.log(
                  `[nft][src][components][pages][rewards][waitTransactionReceipt] transactionHash 2 ${transactionHash} is pending`
                );
                isWaitRunning = false;
                return;
              }
            }

            // Transaction confirm
            web3.eth
              .getTransactionReceipt(transactionHash)
              .then(async function (web3TxReceipt) {
                clearInterval(getReceiptTimerId);
                isWaitRunning = false;
                if (web3TxReceipt == null) {
                  console.log(
                    `[nft][src][components][pages][rewards][waitTransactionReceipt] transactionHash 2 ${transactionHash} is not found`
                  );
                  swal({
                    icon: "error",
                    title: "Failed",
                    text: "Transaction Failed. Please try again!",
                    showConfirmButton: true,
                    showCancelButton: false,
                    allowOutsideClick: true,
                  }).then(() => {
                    refreshPage();
                  });
                } else {
                  if (actionType == "approve") {
                    swal({
                      icon: "success",
                      title: "Approved",
                      text: "Transaction Successful",
                      showConfirmButton: true,
                      showCancelButton: false,
                      allowOutsideClick: true,
                    }).then(() => {
                      refreshPage();
                    });
                  } else if (actionType == "stake") {
                    swal({
                      icon: "success",
                      title: "Success",
                      text: "Staked Successful",
                      showConfirmButton: true,
                      showCancelButton: false,
                      allowOutsideClick: true,
                    }).then(() => {
                      refreshPage();
                    });
                  } else if (actionType == "unstake") {
                    swal({
                      icon: "success",
                      title: "Success",
                      text: "Unstaked Successful",
                      showConfirmButton: true,
                      showCancelButton: false,
                      allowOutsideClick: true,
                    }).then(() => {
                      refreshPage();
                    });
                  } else if (actionType == "claim") {
                    // update transaction hash - 2 with true
                    swal({
                      icon: "success",
                      title: "Success",
                      text: "Rewards claimed Successful",
                      showConfirmButton: true,
                      showCancelButton: false,
                      allowOutsideClick: true,
                    }).then(() => {
                      axios
                        .post(
                          `${BaseUrl}/claimTotalRewards`,
                          {
                            wallet_address: connectedWallet,
                          }
                          //   {
                          //     headers: {
                          //       Authorization: `Bearer ${userDetails?.loginUserToken}`,
                          //     },
                          //   }
                        )
                        .then(function (response) {
                          console.log("response Claim Button", response);
                          refreshPage();
                        })
                        .catch(function (error) {
                          console.log(error.message, "error message");
                        });
                    });
                  }
                }
              })
              .catch(function (error) {
                clearInterval(getReceiptTimerId);
                isWaitRunning = false;
                console.log(
                  `[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 1 ${transactionHash}: ${error}`
                );
                swal({
                  icon: "error",
                  title: "Cancelled",
                  text: error.message,
                  showConfirmButton: true,
                  showCancelButton: false,
                  allowOutsideClick: true,
                }).then(() => {
                  refreshPage();
                });
              });
          })
          .catch(function (error) {
            clearInterval(getReceiptTimerId);
            console.log(
              `[nft][src][components][components][modal][waitTransactionReceipt] Error on transaction receipt 2 ${transactionHash}: ${error}`
            );
            swal({
              icon: "error",
              title: "Cancelled",
              text: error.message,
              showConfirmButton: true,
              showCancelButton: false,
              allowOutsideClick: true,
            }).then(() => {
              refreshPage();
            });
          });
      }
    }, 1000);
  };

  useEffect(() => {
    console.log(nextClaimTime);
    console.log(ifClaimDateArrived);
    console.log(nextClaimTimeString);
  }, [nextClaimTime, ifClaimDateArrived, nextClaimTimeString])

  const checkNextClaim = async () => {
    window.web3 = new Web3(window.ethereum);
    setWeb3(window.web3);
    let NFMClaimRewards = await new window.web3.eth.Contract(
        nfmClaim,
        constants.NFMCLAIMREWARDS
    );
    var nextAllowedClaim = await NFMClaimRewards.methods
        .nextAllowedClaim(connectedWallet)
        .call();
    nextAllowedClaim = parseInt(nextAllowedClaim);
    setNextClaimTime(nextAllowedClaim);
    let currentTime = moment().utc().unix()
    if (currentTime > nextAllowedClaim){
      setIfClaimDateArrived(true);
    }else{
      setNextClaimTimeString(new Date(nextAllowedClaim * 1000).toUTCString());
    }
  }

  useEffect(() => {
    if (connectedWallet.length) {
      checkNextClaim()
      // fetch rewards data
      axios
        .post(`${BaseUrl}/getRewardsList`, {
          wallet_address: connectedWallet,
          // wallet_address: "0xfC0e57e23520E62E5249217b1aAa34279991ae08",
          // following has the claimable rewards
            // wallet_address: "0x0bdefF2d7fbA0cd9da59Ebc2D2C4F1284D4eBc76",
        })
        .then(function (response) {
          console.log("Reward Response", response);
          if (response.status === 200) {
            setRewardResponse(response?.data?.data ?? []);
          } else {
            setRewardResponse([]);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [connectedWallet]);

  useEffect(() => {
    let total = 0;
    let totalClaimed = 0;

    rewardResponse?.nfmStakes?.map((res) => {
      total += res.claimableAmount;
      totalClaimed += res.claimedAmount;
    });

    setClaimAble(total);
    setClaimedAmount(totalClaimed);
  }, [rewardResponse]);

  console.log(rewardResponse, "rewardResponse");

  return (
    <div className="mt-3 reward-page-new">
      <div className="rewards-box-section">
        <h3>Reward Status</h3>
        <div className="rewards-boxes-claim">
          {/* //Rewards BOxes */}
          <div className="rewards-boxes">
            <div className="reward-box">
              <p className="mb-2">Claimable Rewards</p>
              <h2>
                <span>{connectedWallet.length ? claimAble: 0} </span> NCash
              </h2>
            </div>
            <div className="reward-box">
              <p className="mb-2">Claimed Rewards</p>
              <h2>
                <span>{connectedWallet.length ? claimedAmount: 0} </span> NCash
              </h2>
            </div>
          </div>
          {/* Claim button */}
          <div className="claim-button">
            {/* <div className="box-det"> */}
            {/* <div className="gradient-box"> */}
            {/* <div className="field active"> */}

            {claimAble < 1 || !(ifClaimDateArrived)  || !connectedWallet.length ? null : (
              <button
                onClick={getClaimRewardsSignature}
                className="connect-wallet-btn "
                
              >
                Claim Rewards
              </button>
             )}
            {
              !(ifClaimDateArrived) && (connectedWallet.length > 0) && (
                  <p>
                    The rewards can be next claimed from { nextClaimTimeString }
                  </p>
              )
            }
          </div>
        </div>
      </div>

      <div className="rewards-table">
        <div className="dfjb align-items-center">
          <h3 className="mb-0">Reward Transactions</h3>
          {/* <div className="dropdown-rewards">
            <select name="rewardType" id="" onChange={e=> setRewardType(e.target.value)}>
              <option value="">All</option>
              <option value="genesis">Genesis</option>
              <option value="nfm">NFM</option>
            </select>
          </div> */}
        </div>

        {(rewardResponse?.length ?? 0) && connectedWallet.length ? (
          <table
            id="order-table"
            className="table de-table table-rank table-font-size-reduce table-responsive"
          >
            <thead>
              <tr>
                <th scope="col" className="first-head">
                  Tier
                </th>
                <th scope="col" className="right">
                  Total Claimed Amount
                </th>
                <th scope="col" className="right">
                  Staked Time
                </th>

                <th scope="col" className="right">
                  <p className="mb-0 lh-1">
                    Claimable Amount <br /> <small>(NCash)</small>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              {rewardResponse.map((product) => (
                <tr>
                  <td className="right" data-label="Tier">
                    {product.tier}
                  </td>
                  <td
                    className="right staked-by-tbl"
                    data-label="Total Claimed Amount"
                  >
                    <span>
                      {" "}
                      {product?.claimedAmount ? product.claimedAmount : 0}
                    </span>
                  </td>
                  <td className=" right " data-label="Staked Time">
                    {moment(product?.stakeTime).format("DD-MMM-YYYY hh:mm:ss")}
                  </td>
                  <td className="right" data-label="Claimable Amount">
                    {product.claimableAmount} NCash
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </div>

      <p className="text-right mt-3 mb-1">
        Rewards are calculated and shown till the previous night midnight.
        Staking done today, will start seeing rewards from midnight tonight.
      </p>
      <p className="text-right ">
        Please use Avalanche network on metamask to claim & Rewards can be claimed after 30 days from last claim
      </p>
    </div>
  );
};
export default MyRewards;
